import { showDialogWithData, showToast } from "../guest-slices/other.slice"
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { BASEURI, headers } from "../../utils/helper"
import { asyncThunkWrapper } from "../thunkHandler"
import { CHECK_EMAIL } from "../../utils/keywords"
import router from "../../routes/routes"
import { Cookies } from "react-cookie"
import axios from "axios"

const cookies = new Cookies()

// Handle user login
export const handleUserLoginReq = createAsyncThunk("handleUserLoginReq", async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.post(`${BASEURI}/user/auth/login`, data)

    if (response.data?.success) {
      if (response?.data?.data?.token) {
        const maxAge = 24 * 60 * 60;
        cookies.set("token", response?.data?.data?.token, { path: "/", maxAge })
      }
      dispatch(showToast({
        type: "success",
        message: response.data?.message
      }))
      return response.data?.data
    } else {
      dispatch(showDialogWithData({
        type: CHECK_EMAIL,
        data: { email: response?.data?.email }
      }))
      const newErr = response.data?.error || "Something went wrong here!"
      if (newErr.toLowerCase().includes("verify your email")) {
        dispatch(showToast({ type: "success", message: newErr }))
      } else {
        dispatch(showToast({ type: "error", message: newErr }))
      }
    }

    return response
  } catch (error) {
    const newErr = error?.response?.data?.error || "Something went wrong!"
    if (newErr.toLowerCase().includes("verify your email")) {
      dispatch(showToast({ type: "success", message: newErr }))
    } else {
      dispatch(showToast({ type: "error", message: newErr }))
    }
    return rejectWithValue(error)
  }
})

// Handle user login with Google/Facebook
export const handleLoginWithAppsReq = createAsyncThunk("handleLoginWithAppsReq", async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.post(`${BASEURI}/user/auth/register-with-app`, data)

    if (response.data?.success) {
      if (response?.data?.data?.token) {
        cookies.set("token", response?.data?.data?.token, { path: "/" })
      }
      dispatch(showToast({
        type: "success",
        message: response.data?.message
      }))
      return response.data?.data
    } else {
      dispatch(showDialogWithData({
        type: CHECK_EMAIL,
        data: { email: response?.data?.email }
      }))
      const newErr = response.data?.error || "Something went wrong here!"
      if (newErr.toLowerCase().includes("verify your email")) {
        dispatch(showToast({ type: "success", message: newErr }))
      } else {
        dispatch(showToast({ type: "error", message: newErr }))
      }
    }

    return response
  } catch (error) {
    const newErr = error?.response?.data?.error || "Something went wrong!"
    if (newErr.toLowerCase().includes("verify your email")) {
      dispatch(showToast({ type: "success", message: newErr }))
    } else {
      dispatch(showToast({ type: "error", message: newErr }))
    }
    return rejectWithValue(error)
  }
})

// Handle email verification
export const handleEmailVerificationReq = createAsyncThunk("handleUserLoginReq", async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.post(`${BASEURI}/user/auth/email-verification`, data)

    if (response.data?.success) {
      if (response?.data?.data?.token) {
        cookies.set("token", response?.data?.data?.token, { path: "/" })
      }
      dispatch(showToast({
        type: "success",
        message: response.data?.message
      }))
      return response.data?.data
    } else {
      dispatch(showDialogWithData({
        type: CHECK_EMAIL,
        data: { email: response?.data?.email }
      }))
      const newErr = response.data?.error || "Something went wrong here!"
      dispatch(showToast({ type: "error", message: newErr }))
    }

    return response
  } catch (error) {
    const newErr = error?.response?.data?.error === "jwt expired" ?
      "Link expired!" : "Something went wrong here!"
    dispatch(showToast({ type: "error", message: newErr }))
    return rejectWithValue(error)
  }
})

// Handle check username
export const handleCheckUsernameReq = createAsyncThunk("handleCheckUsernameReq", async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.post(`${BASEURI}/user/auth/check-username`, data)

    if (response.data?.success) {
      return response.data
    } else {
      const newErr = response.data?.error || "Something went wrong here!"
      dispatch(showToast({ type: "error", message: newErr }))
    }

    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

// Handle update profile
export const handleUpdateProfileReq = createAsyncThunk(
  "update",
  async (data, thunkAPI) => {
    return asyncThunkWrapper(
      {
        data,
        method: "POST",
        headers: {
          ...headers(),
          "Content-Type": "multipart/form-data",
        }, url: `${BASEURI}/user/auth/update-profile`,

      },
      thunkAPI
    )
  }
)
export const getUpdatedDetailsReq = createAsyncThunk("getUpdatedDetailsReq", async (_, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.get(`${BASEURI}/specialist/auth/get-updated-details`, {
      headers: headers()
    })
    if (response.data?.success) {
      return response.data?.data
    }

    return response
  } catch (error) {
    if (error.response.data.redirect) {
      dispatch({ type: "Logout" })
    }
    return rejectWithValue(error)
  }
})
// Handle google login
export const handleGoogleLoginReq = createAsyncThunk(
  "handleGoogleLoginReq",
  async (data, thunkAPI) => {
    return asyncThunkWrapper(
      {
        data,
        method: "POST",
        headers: headers(),
        url: `${BASEURI}/user/auth/google`,
      },
      thunkAPI
    )
  }
)

const initialState = {
  specialist: {},
  loadings: {},
  member: null,
  questionnaire: {},
}
const auth = createSlice({
  name: "auth",
  initialState,
  extraReducers: (builder) => {
    // Handle user login
    builder.addCase(handleGoogleLoginReq?.pending, (state) => {
      state.loadings.googleLogin = true
    })
    builder.addCase(handleGoogleLoginReq?.rejected, (state) => {
      delete state?.loadings?.googleLogin
    })
    builder.addCase(handleGoogleLoginReq?.fulfilled, (state, { payload, meta }) => {
      const { user, token } = payload || {}
      const { stay } = meta.arg
      if (token) { cookies.set("token", token, { path: "/" }) }
      const { userRole, verification } = user || {}
      if (!user || !userRole) return
      if (userRole === "specialist" && verification?.currentStep !== "confirmation") {
        setTimeout(() => {
          router?.navigate('/specialist-registration')
        }, 500)
      } else {
        if (!stay) {
          setTimeout(() => {
            router?.navigate(`/${userRole}/profile`)
          }, 500)
        }
      }

      state[userRole] = user
      delete state?.loadings?.googleLogin
    })

    // Handle user login
    builder.addCase(handleUserLoginReq?.pending, (state) => {
      state.loadings.login = true
    })
    builder.addCase(handleUserLoginReq?.rejected, (state) => {
      delete state?.loadings?.login
    })
    builder.addCase(handleUserLoginReq?.fulfilled, (state, { payload, meta }) => {
      const { user } = payload || {}
      const { userRole, verification } = user || {}
      const { stay } = meta.arg;
      if (!user || !userRole) return
      if (userRole === "specialist" && verification?.currentStep !== "confirmation") {
        setTimeout(() => {
          router?.navigate('/specialist-registration')
        }, 500)
      } else {
        if (userRole === "specialist" || !stay) {
          setTimeout(() => {
            router?.navigate(`/${userRole}/profile`)
          }, 500)
        }

      }

      state[userRole] = user
      delete state?.loadings?.login
    })

    // Handle login with Google/Facebook
    builder.addCase(handleLoginWithAppsReq?.pending, (state, { meta }) => {
      const { signupType } = meta.arg
      signupType === "google" ?
        state.loadings.googleLogin = true :
        state.loadings.loginFB = true
    })
    builder.addCase(handleLoginWithAppsReq?.rejected, (state) => {
      delete state?.loadings?.loginFB
      delete state?.loadings?.googleLogin
    })
    builder.addCase(handleLoginWithAppsReq?.fulfilled, (state, { payload, meta }) => {
      const { user } = payload || {}
      const { userRole, verification } = user || {}
      const { stay } = meta.arg

      if (!user || !userRole) return
      if (userRole === "specialist" && verification?.currentStep !== "confirmation") {
        setTimeout(() => {
          router?.navigate('/specialist-registration')
        }, 500)
      } else {
        if (userRole === "specialist" || !stay) {
          setTimeout(() => {
            router?.navigate(`/${userRole}/profile`)
          }, 500)
        }
      }

      state[userRole] = user
      delete state?.loadings?.loginFB
      delete state?.loadings?.googleLogin
    })
    builder.addCase(getUpdatedDetailsReq?.fulfilled, (state, { payload }) => {
      state.specialist = payload
    })
    // Handle check username
    builder.addCase(handleCheckUsernameReq.pending, (state) => {
      state.username = { loading: true }
    })
    builder.addCase(handleCheckUsernameReq.rejected, (state, { payload }) => {
      delete state?.username?.loading
      state.username = { error: payload?.response?.data?.error }
    })
    builder.addCase(handleCheckUsernameReq.fulfilled, (state, { payload }) => {
      delete state?.username?.loading
      state.username = { message: payload?.message }
    })
    builder.addCase(handleUpdateProfileReq.pending, (state) => {
      state.loadings.update = true
    })
    builder.addCase(handleUpdateProfileReq.rejected, (state) => {
      delete state.loadings.update
    })
    builder.addCase(handleUpdateProfileReq.fulfilled, (state, { payload }) => {
      const { user, address } = payload || {}
      if (user) {
        state.member = {
          ...state.member,
          ...user,
          address
        }


      }

      delete state.loadings.update
    })

    // Logout
    builder.addCase("Logout", () => {
      cookies.remove("token", { path: "/" })
      router.navigate("/login")
      return initialState
    })


  },
  reducers: {
    setQuestionnaire: (state, { payload }) => {
      state.questionnaire = {
        ...state.questionnaire,
        ...payload,
      }
    },

    clearQuestionnaire: (state) => {
      state.questionnaire = {}
    },

    clearSessionalData: (state) => {
      const { country, preferredLanguage, timezone, supportFor } = state.questionnaire
      state.questionnaire = {
        country,
        preferredLanguage,
        timezone,
        supportFor
      }
    }


  }


})

export const {
  setQuestionnaire,
  clearQuestionnaire,
  clearSessionalData
} = auth.actions

export default auth.reducer